module.exports = __webpack_public_path__ + "files/b5ab196e79e391c2093184b5dff8e275.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/flags-1.png
// module id = 530
// module chunks = 76